import {
  Apps,
  FormatListBulleted,
  KeyboardArrowDown,
  Menu,
  Search,
} from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import { useRef } from "react";
import { jobApi } from "../Component/API/Api";
import Job from "../Component/Homepage Components/Latest Job/Job.js";
import CategoryListJob from "./CategoryListJob.js";
import CategoryListJobRES from "./CategoryListJobRES.js";
import { useParams } from "react-router-dom";
// import loading from "../Vendors/Images/loading.gif";

const JobListAgency = () => {
  const {agency} = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [firstLoadIndicator, setFirstLoadIndicator] = useState(true);

  const [jobListData, setJobListData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = useState(1);
  const [resLeftToggle, setResLeftToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [sourceValueId, setSourceValueId] = useState("");
  const [source, setSource] = useState("category");

 useEffect(() => {
    fetch(`https://aps.songjukti.com/profile/login/api_freelancer/expert_job_list.php?c_refer=${agency}&page=${page}`)
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [page, agency]);

  // useEffect(() => {
  //   fetchJobs();
  // }, [page, category, subCategory]);

    const handleSearch = () => {
    setLoading(true);

    fetch(
        `https://aps.songjukti.com/profile/login/api_search/sear_job.php?keyword=${searchText}&page=${page}&category=${category}&subCategory=${subCategory}`
    )
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result);
        // if (result.length > 0) {
        //   setLoading(false);
        //   setNotFound(false);
        // } else {
        //   setLoading(false);
        //   setNotFound(true);
        // }
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box>
      <Container sx={{ mt: { xs: 6, md: 2 } }}>
        <Grid container spacing={2}>
          {/* Left Sidebar */}
          

          {/* Main Content */}
          <Grid item xs={12} md={12}>
            <Stack sx={{ p: 2 }}>
              {/* Search Bar */}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                sx={{ mb: 2 }}
              >
                <IconButton
                  size="small"
                  sx={{ display: { xs: "block", md: "none" } }}
                  onClick={() => setResLeftToggle(!resLeftToggle)}
                >
                  <Menu />
                </IconButton>

                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, display: { xs: "none", md: "block" } }}
                >
                  All Listed Jobs of {jobListData?.[0]?.job_poster_name}
                </Typography>

                <OutlinedInput
                  placeholder="Search jobs..."
                  color="success"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  sx={{ width: "100%", maxWidth: 400 }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={handleSearch} size="small">
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Stack>

              {/* Job List */}
              {loading ? (
                <Box sx={{ textAlign: "center", mt: 5 }}>
                  <CircularProgress color="success" />
                </Box>
              ) : notFound ? (
                <Typography align="center" sx={{ mt: 10 }} fontSize={24}>
                  No jobs found!
                </Typography>
              ) : (
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    {jobListData.map((data) => (
                      <Grid item xs={12} key={data.job_refer}>
                        <Job jobData={data} />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}

              {/* Pagination */}
              {!loading && !notFound && (
                <Pagination
                  count={10} // Replace with dynamic total pages when available
                  page={page}
                  onChange={handlePageChange}
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 3, mx: "auto" }}
                />
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default JobListAgency;
